export const DOMESTIC = 'DOMESTIC';
export const INTERNATIONAL = 'INTERNATIONAL';
export const NATIONAL = 'national';
export const LEAGUE = 'LEAGUE';
